<div class="h-full p-4">
  <div class="mb-3 flex flex-col gap-1">
    <div class="flex items-center gap-1.5 min-w-0">
      @if (requiredRoleUnassigned && (groupEdit || formSubmitted)) {
        <ion-icon
          name="alert-circle"
          class="size-5 text-bright-crimson shrink-0 animate-bounce"
          aria-hidden="true"
        ></ion-icon>
      }
      <h2
        id="contact-role-assignment-required"
        class="text-sm font-medium"
        [ngClass]="requiredRoleUnassigned && (groupEdit || formSubmitted) ? 'text-bright-crimson' : 'text-grey-blue'"
      >
        Role Assignment
        @if (requiredRoleUnassigned && (groupEdit || formSubmitted)) {
          Required
        }
      </h2>
    </div>
    <p class="text-xs font-normal text-grey-mid">Match contacts to the responsibilities they cover.</p>
  </div>

  <div class="lg:max-h-[22rem] 2xl:max-h-none" [ngClass]="{ relative: !reviewMode }">
    <div
      class="pointer-events-none absolute inset-x-0 top-0 z-[1] hidden h-4 bg-[linear-gradient(to_bottom,var(--color-grey-light-concrete),rgba(244,245,244,0))] transition-opacity duration-150 lg:block 2xl:hidden"
      [ngClass]="{ 'opacity-0': !canScrollRolesUp }"
    ></div>
    <div
      class="hidden lg:flex 2xl:hidden absolute top-0 left-0 w-full justify-center z-10 pointer-events-none"
      [ngClass]="{ 'opacity-0': !canScrollRolesUp }"
    >
      <button
        id="roles-scroll-up"
        class="btn-default btn-xs m-0 flex items-center justify-center shadow-md pointer-events-auto"
        (click)="scrollRoles('up')"
        aria-label="Scroll up to reveal more roles"
      >
        <ion-icon class="text-sm" name="chevron-up-outline"></ion-icon>
      </button>
    </div>

    <div
      #rolesScrollBody
      id="roleAssignment"
      class="z-0 grid grid-cols-1 gap-2 lg:max-h-[20rem] lg:grid-cols-1 lg:pr-1 2xl:max-h-none 2xl:grid-cols-2 2xl:overflow-visible 2xl:pr-0"
      [ngClass]="{ 'relative lg:overflow-y-auto': !reviewMode }"
      (scroll)="updateRolesScrollState()"
    >
      @for (contactRole of requiredContactRoles; track contactRole) {
        <app-contact-role
          class="block min-w-0"
          [contactRole]="contactRole"
          [groupType]="groupType"
          [contactFormGroups]="contactFormGroups"
          [contactsFormArray]="contactsFormArray"
          [required]="true"
          [reviewMode]="reviewMode"
          [groupEdit]="groupEdit"
          [formSubmitted]="formSubmitted"
          [compactDesktop]="true"
          (addContact)="addEditContact.emit($event)"
          (updateAllCustomers)="updateAllCustomers.emit()"
        ></app-contact-role>
      }
      @for (contactRole of visibleOptionalRoles; track contactRole) {
        <app-contact-role
          class="block min-w-0"
          [contactRole]="contactRole"
          [groupType]="groupType"
          [contactFormGroups]="contactFormGroups"
          [contactsFormArray]="contactsFormArray"
          [reviewMode]="reviewMode"
          [groupEdit]="groupEdit"
          [formSubmitted]="formSubmitted"
          [compactDesktop]="true"
          (addContact)="addEditContact.emit($event)"
          (updateAllCustomers)="updateAllCustomers.emit()"
        ></app-contact-role>
      }
      @if (hiddenOptionalRoles.length) {
        @if (!showMoreRoles && !canScrollRolesUp && !canScrollRolesDown) {
          <div class="min-w-0 2xl:col-span-2 flex justify-center pt-1">
            <button
              id="show-more-roles"
              type="button"
              class="btn-default btn-xs inline-flex items-center gap-1"
              (click)="showMoreRoles = true"
            >
              <ion-icon name="chevron-down-outline" class="text-sm"></ion-icon>
              <span>Show more</span>
            </button>
          </div>
        } @else {
          @for (contactRole of hiddenOptionalRoles; track contactRole) {
            <app-contact-role
              class="block min-w-0"
              [contactRole]="contactRole"
              [groupType]="groupType"
              [contactFormGroups]="contactFormGroups"
              [contactsFormArray]="contactsFormArray"
              [reviewMode]="reviewMode"
              [groupEdit]="groupEdit"
              [formSubmitted]="formSubmitted"
              [compactDesktop]="true"
              (addContact)="addEditContact.emit($event)"
              (updateAllCustomers)="updateAllCustomers.emit()"
            ></app-contact-role>
          }
        }
      }
    </div>

    <div
      class="hidden lg:flex 2xl:hidden absolute bottom-0 left-0 w-full justify-center z-10 pointer-events-none"
      [ngClass]="{ 'opacity-0': !canScrollRolesDown }"
    >
      <button
        id="roles-scroll-down"
        class="btn-default btn-xs m-0 flex items-center justify-center shadow-md pointer-events-auto"
        (click)="scrollRoles('down')"
        aria-label="Scroll down to reveal more roles"
      >
        <ion-icon class="text-sm" name="chevron-down-outline"></ion-icon>
      </button>
    </div>
    <div
      class="pointer-events-none absolute inset-x-0 bottom-0 z-[1] hidden h-4 bg-[linear-gradient(to_top,var(--color-grey-light-concrete),rgba(244,245,244,0))] transition-opacity duration-150 lg:block 2xl:hidden"
      [ngClass]="{ 'opacity-0': !canScrollRolesDown }"
    ></div>
  </div>
</div>
